var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPencil = function SvgPencil(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.50002 1.69794L7.45194 3.6423L2.7345 8.35974L0.79014 6.41538L5.50002 1.69794ZM0.19566 8.70666C0.185816 8.77556 0.209723 8.8454 0.25941 8.89415C0.307691 8.94478 0.378004 8.96822 0.44691 8.9579L2.08563 8.7704L0.38127 7.06233L0.19566 8.70666ZM8.12502 1.79922L7.34502 1.01922C7.1908 0.864524 6.98128 0.777344 6.76283 0.777344C6.54439 0.777344 6.33486 0.864531 6.18064 1.01922L6.03251 1.16734L7.98251 3.1117L8.13064 2.96358C8.28533 2.80935 8.37251 2.59983 8.37251 2.38138C8.37251 2.16295 8.28532 1.95342 8.13064 1.79919L8.12502 1.79922Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pencil.85050eff.svg";
export { ForwardRef as ReactComponent };